import { useContext } from 'react';
import { TenantContext } from '../context/tenant-context';

/** A prova deste build. Fornecida pelo `App`, a partir de `VITE_TENANT`. */
export function useTenant() {
  const tenant = useContext(TenantContext);
  if (!tenant) {
    throw new Error('useTenant must be used within TenantContext.Provider');
  }
  return tenant;
}
